function extractUserId(email: string, asurite?: string) {
  return asurite || email?.split('@').shift() || '';
}

export { extractUserId };
